module.exports = "<div class=\"btn-group btn-group-without-decoration btn-group-icons\"></div>";